import {
  BUTTON_TITLE,
  BUTTON_SUBTITLE,
  BUTTON_NUMBERING,
  BUTTON_BULLETS,
  BUTTON_BLOCKQUOTE,
  BUTTON_CODE_BLOCK,
  BUTTON_LINK,
  BUTTON_ALIGN_LEFT,
  BUTTON_ALIGN_RIGHT,
  BUTTON_ALIGN_CENTER,
  BUTTON_ALIGN_JUSTIFY,
} from '../constants/buttons';

/*
  Keys mapped by default:
  https://github.com/facebook/draft-js/blob/e1d3f7657f053fedf3d29346d3a4de81399b068b/src/component/utils/getDefaultKeyBinding.js#L77

  bold Command+B
  italic Command+I
  underline Command+U
*/
export const BUTTON_SHORTCUTS = {
  [BUTTON_TITLE]: { command: true, shift: true, key: '1' },
  [BUTTON_SUBTITLE]: { command: true, shift: true, key: '2' },
  [BUTTON_NUMBERING]: { command: true, shift: true, key: 'M' },
  [BUTTON_BULLETS]: { command: true, shift: true, key: 'L' },
  [BUTTON_BLOCKQUOTE]: { command: true, shift: true, key: '9' },
  [BUTTON_CODE_BLOCK]: { command: true, shift: true, key: '8' },
  [BUTTON_LINK]: { command: true, key: 'K' },
  [BUTTON_ALIGN_LEFT]: { command: true, key: 'L' },
  [BUTTON_ALIGN_RIGHT]: { command: true, key: 'R' },
  [BUTTON_ALIGN_CENTER]: { command: true, key: 'E' },
  [BUTTON_ALIGN_JUSTIFY]: { command: true, key: 'J' },
};



// WEBPACK FOOTER //
// ./app/components/text-editor/constants/button-shortcuts.js